import React, { useState, useEffect } from "react";
import { APIURL } from "../../redux/action/config";
import axios from "axios";
import dateFormat from "dateformat";

const RecentOrderView = (props) => {
  const [viewDetails, setViewDetails] = useState();
  useEffect(() => {
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(`${APIURL}/api/v1/order/${props.id}`, config)
      .then((response) => {
        setViewDetails(response.data);
      })
      .catch((error) => console.log("error", error));
  }, [props.id]);
  const recentOrder = viewDetails?.data?.order ? viewDetails?.data?.order : "";
  const recentOrderStatus = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "Request Accepted";
      case 3:
        return "Completed";
      case 4:
        return "Canceled";
      default:
    }
  };
  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={props.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                <form
                  id="kt_modal_new_target_form"
                  className="form fv-plugins-bootstrap5 fv-plugins-framework"
                >
                  <div className="mb-8 text-center">
                    <h1 className="mb-3 text-primary">Order Details</h1>
                    {/* <div className="text-muted fw-bold fs-5">
                      If you need more info, please check out.
                    </div> */}
                  </div>
                  <div className="separator d-flex flex-center mb-8"></div>
                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>SR No.</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {recentOrder?.invoice_no}
                      </div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Customer Name</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {`${
                          recentOrder?.customer_id?.firstName
                            ? recentOrder?.customer_id?.firstName
                            : ""
                        } ${
                          recentOrder?.customer_id?.lastName
                            ? recentOrder?.customer_id?.lastName
                            : ""
                        }`}
                      </div>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Date</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {dateFormat(recentOrder?.date, "d mmmm , yyyy")}
                      </div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Requested Service </span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {recentOrder?.service_id?.name}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Staff Assigned </span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">NA</div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Fleet Assigned </span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">NA</div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Status</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {recentOrderStatus(
                          recentOrder?.customer_id?.customer_status
                        )}
                      </div>
                    </div>
                  </div>
                </form>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RecentOrderView;
